<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'seotrCrud'"
          crudName="Setores"
          newText="Novo Setor"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="false"
          :enableEdit="false"
          :enableDelete="false"
          :enableActive="false"
          :enableView="true"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      unidades: [],
      table: "setorTable",
      showMessageImport: false,
      setorCrud: {},
      pages: [],
      url: "",
      columns: ["id", "unidade_id", "nome", "ativo", "classifica", "finaliza", "medicacao", "espera", "envia_ares_triagem", "prioridade", "agenda_consulta", "actions"],
      tableData: ["id", "unidade_id", "nome", "ativo", "classifica", "finaliza", "medicacao", "espera", "envia_ares_triagem", "prioridade", "agenda_consulta"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "unidade_id", "nome", 'ativo', "classifica", "finaliza", "medicacao", "espera", "envia_ares_triagem", "prioridade", "agenda_consulta"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          unidade_id: "Unidade",
          nome: "Nome",
          ativo: "Ativo",
          classifica: "Classifica Risco",
          finaliza: "Finaliza Senha",
          medicacao: "Medicação",
          espera: "Espera",
          prioridade: "Muda prioridade",
          envia_ares_triagem: "Envia para Ares Triagem",
          agenda_consulta: "Agenda consulta",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          unidade_id: [],
          ativo: [
            {
              id: 1,
              text: "Ativo",
            },
            {
              id: 0,
              text: "Inativo",
            },
          ],
          classifica: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          finaliza: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          medicacao: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          espera: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          envia_ares_triagem: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          prioridade: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          agenda_consulta: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
        },
        templates: {
          ativo: function (h, row, index) {
            return row.ativo ? (<span class="badge badge-primary">Ativo</span>) : (<span class="badge badge-secondary">Inativo</span>) 
          },
          unidade_id: function (h, row, index) {
            return row.unidade ? row.unidade.nome : 'Não disponível';
          },
          classifica: function (h, row, index) {
            return row.classifica ? (<span class="badge badge-primary">Sim</span>) : (<span class="badge badge-secondary">Não</span>);
          }, 
          finaliza: function (h, row, index) {
            return row.finaliza ? (<span class="badge badge-primary">Sim</span>) : (<span class="badge badge-secondary">Não</span>);
          },
          medicacao: function (h, row, index) {
            return row.medicacao ? (<span class="badge badge-primary">Sim</span>) : (<span class="badge badge-secondary">Não</span>);
          },
          espera: function (h, row, index) {
            return row.espera ? (<span class="badge badge-primary">Sim</span>) : (<span class="badge badge-secondary">Não</span>);
          },
          envia_ares_triagem: function (h, row, index) {
            return row.envia_ares_triagem ? (<span class="badge badge-primary">Sim</span>) : (<span class="badge badge-secondary">Não</span>);
          },
          prioridade: function (h, row, index) {
            return row.prioridade ? (<span class="badge badge-primary">Sim</span>) : (<span class="badge badge-secondary">Não</span>);
          },
          agenda_consulta: function (h, row, index) {
            return row.agenda_consulta ? (<span class="badge badge-primary">Sim</span>) : (<span class="badge badge-secondary">Não</span>);
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ['unidade'];

          return this.$http.get(this.url + "?orderByDesc=id&" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "setores/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        unidade_id: "unidade_id",
        nome: "nome",
        ativo: "ativo",
        classifica: "classifica",
        finaliza: "finaliza",
        medicacao: "medicacao",
        espera: "espera",
        envia_ares_triagem: "envia_ares_triagem",
        prioridade: "prioridade",
        agenda_consulta: "agenda_consulta",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades";
      
      axios
        .get(api)
        .then((response) => {
          response.data.data.forEach(unidade => {
            self.unidades.push({id: unidade.id, text: unidade.nome});
          });

          self.options.listColumns.unidade_id = self.unidades;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getUnidades();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>